import axios from 'axios';
import { EmailNotification, PreOrderData, ProcessResult } from '../Interfaces';
import { getCreateEmailNotficationEndpoint } from '../Endpoints';
import { generatePreOrderNotificationEmail, getDefaultHeaders } from '../Utils';

export const createEmailNotification = async (preOrder: PreOrderData, preOrderCode: string, token: string, managementId: string, companyId: number, userName: string): Promise<ProcessResult> => {
    try{
        if (!!process.env.REACT_APP_EMAIL_TO_NOTIFICATION && process.env.REACT_APP_EMAIL_TO_NOTIFICATION.length > 0){
            const notificationRequest: EmailNotification = {
                ApplicationId: 'Koordine',
                CompanyId: companyId,
                EmailTo: process.env.REACT_APP_EMAIL_TO_NOTIFICATION,
                CC: !!process.env.REACT_APP_CC_TO_NOTIFICATION && process.env.REACT_APP_CC_TO_NOTIFICATION?.length > 0 ? process.env.REACT_APP_CC_TO_NOTIFICATION : '',
                CCO: !!process.env.REACT_APP_CCO_TO_NOTIFICATION && process.env.REACT_APP_CCO_TO_NOTIFICATION?.length > 0 ? process.env.REACT_APP_CCO_TO_NOTIFICATION : '',
                Subject: 'Nueva Pre-Orden',
                Body: generatePreOrderNotificationEmail(preOrder,preOrderCode, userName),
                NotificationStatus: 0,
                RegisterStatus: 1
            }
        
            const {data, status} = await axios.post(getCreateEmailNotficationEndpoint, notificationRequest, getDefaultHeaders(token, managementId));
            if (status === 200 && (data.Ok || data.ok)){
                return {Ok: true, data: data.data};
            }

            return {Ok: false};
        }

        return {Ok: false, data: 'No email to has been configured.'};
    }
    catch (error: any){
        console.error("Error on createEmailNotification >>> ", JSON.stringify(error));
        return {Ok: false, data: error.message};
    }
}